import { render, staticRenderFns } from "./job-info.vue?vue&type=template&id=6e5f320e&scoped=true"
import script from "./job-info.vue?vue&type=script&lang=ts"
export * from "./job-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f320e",
  null
  
)

export default component.exports